import TrackingsModel from 'src/model/modules/trackingInfo.model';
import TrackingInfoModel from 'src/model/trackingInfo.model';
import DateRangeModel from 'src/model/dateRange.model';

interface IPagination {
  pageNumber: number;
  pageSize: number;
  totalElements: number;
  totalPages: number;
}

const TrackingSel = (state: any): TrackingsModel => state.tracking;

export const contentSel = (state: any): TrackingInfoModel[] =>
  TrackingSel(state).content;
export const getInvoicesIsPendingSel = (state: any): boolean =>
  TrackingSel(state).getInvoicesIsPending;
export const getDatesFilterSel = (state: any): DateRangeModel | null =>
  TrackingSel(state).datesFilter;
export const gettrackingPaginationSel = (state: any): IPagination =>
  TrackingSel(state).pagination;
